<template>
  <div>
    <button
      href="#"
      class="mctb_navigation_01_ mctb-carousel-prev-next-button mctb-carousel-previous"
      :class="{ 'mctb-carousel-navigation--disabled': !mctbcanAdvanceBackward }"
      :style="`padding: ${clickTargetleftSize}px; margin-right: -${clickTargetSize}px;`"
      @click.prevent="triggerPageAdvance('backward')"
    >
      &#60;
    </button>
    <button
      href="#"
      class="mctb_navigation_02_ mctb-carousel-prev-next-button mctb-carousel-next"
      :class="{ 'mctb-carousel-navigation--disabled': !mctbcanAdvanceForward }"
      :style="`padding: ${clickTargetleftSize}px; margin-left: -${clickTargetSize}px;`"
      @click.prevent="triggerPageAdvance()"
    >
      &#62;
    </button>
  </div>
</template>
<script>
export default {
  name: 'navigation',
  props: {
    clickTargetSize: {
      type: Number,
      default: 8,
    },
    clickTargetleftSize: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      parentContainer: this.$parent,
    };
  },
  computed: {
    mctbcanAdvanceForward() {
      return this.parentContainer.mctbcanAdvanceForward || false;
    },
    mctbcanAdvanceBackward() {
      return this.parentContainer.mctbcanAdvanceBackward || false;
    },
  },
  methods: {
    triggerPageAdvance(direction) {
      if (direction) {
        /* istanbul ignore next */
        this.$parent.mctbadvancePage(direction);
      } else {
        /* istanbul ignore next */
        this.$parent.mctbadvancePage();
      }
    },
  },
};
</script>
